import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { default as BaseButton } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import PublishIcon from '@material-ui/icons/Publish';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(() => ({
  root: {
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: '4px',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  icon: {
    marginRight: '0.3rem',
    fontSize: '1rem',
  },
}));

const classNames = (...names) => {
  return names.filter(name => name !== undefined).join(' ');
};

const ControlButton = ({label, to, onClick, variant='contained', icon=null, disabled=false, busy=false, className=undefined, ...props}) => {
  const classes = useStyles();
  const action = busy ? {} : to ? {component: Link, to: to} : {onClick : onClick};
  return (
    <BaseButton
      className={classNames(classes.root, className)}
      variant={variant}
      disabled={disabled}
      disableRipple
      {...props}
      {...action}
    >
      {!busy && icon === 'upload' ? <PublishIcon className={classes.icon} /> : null}
      {!busy && icon === 'more' ? <MoreVertIcon className={classes.icon} /> : null}
      {!busy && icon === 'download' ? <ArrowDownwardIcon className={classes.icon} /> : null}
      {!busy && icon === 'forward' ? <ArrowForwardIcon className={classes.icon} /> : null}
      {!busy && icon === 'delete' ? <DeleteIcon className={classes.icon} /> : null}
      {label}
      {!busy && icon === 'dropdown' ? <ArrowDropDownIcon className={classes.icon} /> : null}
      {busy ? <CircularProgress className={classes.spinner} color="primary" size={15} thickness={6}/> : null}
    </BaseButton>
  );
};

ControlButton.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  icon: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  color: PropTypes.string,
  cssStyle: PropTypes.string,
  pointer: PropTypes.string,
  disabled: PropTypes.bool,
  busy: PropTypes.bool,
  className: PropTypes.string,
};

export default ControlButton;
